<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="desserts"
          class="elevation-6"
          :search="search"
          dense
        >
          <template v-slot:item.activo="{ item }">
            <v-chip v-if="Number(item.activo) === 1" dense small color="green" dark>Activo</v-chip>
            <v-chip v-else dense small color="red" dark>Inactivo</v-chip>
          </template>

          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Auxiliares</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                small
                color="primary"
                dark
                class="mb-2"
                @click="abrirDialogo()"
              >
                Agregar auxiliar
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                label="Buscar"
                outlined
                dense
                v-model="search"
              ></v-text-field>
            </v-card-text>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon
              v-if="Number(item.activo) === 1"
              small
              color="error"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>

          <template v-slot:no-data>
            <v-btn color="primary" @click="getAuxiliares()">
              Reset
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialog"
      hide-overlay
      persistent
      max-width="400"
    >
      <v-card style="position: relative">
        <v-card-title primary-title>
          {{ formTitle }}
          <v-spacer></v-spacer>
          <v-btn fab small text @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                outlined
                dense
                :items="departamentosModal"
                v-model="area"
                label="Selecciona departamento"
                return-object
                item-value="iddepartamento"
                item-text="departamento"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.departamento }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.area_ticket">
                      Área ticket: {{ item.area_ticket }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>

              <v-autocomplete
                outlined
                dense
                :items="puestos"
                v-model="puesto"
                label="Selecciona un puesto"
                return-object
                item-value="idpuesto"
                item-text="puesto"
                :disabled="!area"
              ></v-autocomplete>

              <v-autocomplete
                outlined
                dense
                :items="usuariosActivos"
                v-model="usuario"
                label="Selecciona un auxiliar"
                return-object
                item-value="id_usuario"
                item-text="nombre_completo"
                :disabled="!puesto"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="close">Cancelar</v-btn>
          <v-btn color="success" text @click="save">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="420">
      <v-card>
        <v-card-title class="text-subtitle-1">
          ¿Eliminar auxiliar?
        </v-card-title>
        <v-card-text>
          Se desactivará a <strong>{{ editedItem.nombre_completo }}</strong>
          del departamento <strong>{{ editedItem.departamento || editedItem.area }}</strong>.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDelete">Cancelar</v-btn>
          <v-btn color="error" text @click="deleteItemConfirm">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>

<script>
  import Alerta from '@/components/alertas/Alerta.vue'
  import carga from '@/components/alertas/carga.vue'
  import validarErrores from '@/mixins/validarErrores'

  export default {
    components: {
      Alerta,
      carga,
    },

    mixins: [validarErrores],

    data: () => ({
      cargar: false,
      areas: [],
      areasTicket: [],
      allPuestos: [],
      usuariosKpi: [],
      jefesActivosIds: [],
      area: null,
      puestos: [],
      puesto: null,
      usuario: null,
      dialog: false,
      dialogDelete: false,
      search: '',
      headers: [
        { text: 'Id', align: 'start', sortable: false, value: 'idauxi_area' },
        { text: 'Nombre', value: 'nombre_completo' },
        { text: 'Departamento', value: 'departamento' },
        { text: 'Área ticket', value: 'area' },
        { text: 'Puesto', value: 'puesto' },
        { text: 'Estatus', value: 'activo', align: 'center' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        idauxi_area: 0,
        id_usuario: 0,
        idareas_ticket: 0,
        idpuesto: 0,
        iddepartamento: 0,
      },
      defaultItem: {
        idauxi_area: 0,
        id_usuario: 0,
        idareas_ticket: 0,
        idpuesto: 0,
        iddepartamento: 0,
      },
      skipCascadeReset: false,
      alive: true,
      catalogoCargado: false,
      catalogoPromise: null,
      mapaDeptAreaTicket: {},
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar auxiliar' : 'Editar auxiliar'
      },

      departamentosModal () {
        return (this.areas || []).filter((depto) => Number(depto.idareas_ticket) > 0)
      },

      usuariosActivos () {
        if (!this.puesto) return []

        const usuariosMap = new Map()
        const usuarioEnEdicion = Number(this.editedItem.id_usuario) || 0

        this.usuariosKpi.forEach((usuario) => {
          if (!usuario || usuario.id_usuario == null) return
          if (usuario.activo_sn != null && Number(usuario.activo_sn) !== 1) return

          const idUsuario = Number(usuario.id_usuario)
          const esUsuarioEnEdicion = usuarioEnEdicion > 0 && idUsuario === usuarioEnEdicion

          if (!esUsuarioEnEdicion && this.jefesActivosIds.has(idUsuario)) return

          const yaEsAuxiliar = !esUsuarioEnEdicion && this.desserts.some((row) => (
            Number(row.id_usuario) === idUsuario
            && Number(row.idauxi_area) !== Number(this.editedItem.idauxi_area)
            && Number(row.activo) === 1
          ))
          if (yaEsAuxiliar) return

          usuariosMap.set(idUsuario, {
            id_usuario: usuario.id_usuario,
            nombre_completo: usuario.nombre_completo,
          })
        })

        return Array.from(usuariosMap.values())
          .sort((a, b) => a.nombre_completo.localeCompare(b.nombre_completo))
      },
    },

    watch: {
      area () {
        this.puestos = this.getPuestosPorDepartamento(this.area)
        if (this.skipCascadeReset) return
        this.puesto = null
        this.usuario = null
      },

      puesto () {
        if (this.skipCascadeReset) return
        this.usuario = null
      },
    },

    async created () {
      this.cargar = true
      await this.getAuxiliares()
      if (this.alive) this.cargar = false
    },

    beforeDestroy () {
      this.alive = false
      this.cargar = false
      this.catalogoPromise = null
      this.catalogoCargado = false
      this.dialog = false
      this.dialogDelete = false
      this.desserts = []
      this.areas = []
      this.allPuestos = []
      this.puestos = []
      this.usuariosKpi = []
      this.areasTicket = []
      this.jefesActivosIds = new Set()
      this.mapaDeptAreaTicket = {}
    },

    methods: {
      guardarSiActivo (fn) {
        if (!this.alive) return
        fn()
      },

      normalizarTexto (value) {
        return (value || '')
          .toString()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .replace(/\s+/g, ' ')
          .trim()
      },

      getIdAreasTicket (departamento) {
        if (!departamento) return null

        if (Number(departamento.idareas_ticket) > 0) {
          return Number(departamento.idareas_ticket)
        }

        const idDepto = Number(departamento.iddepartamento)
        if (idDepto > 0 && this.mapaDeptAreaTicket[idDepto]) {
          return Number(this.mapaDeptAreaTicket[idDepto])
        }

        return null
      },

      getPuestosPorDepartamento (departamento) {
        if (!departamento || departamento.iddepartamento == null) return []

        return this.allPuestos
          .filter((puesto) => (
            Number(puesto.iddepartamento) === Number(departamento.iddepartamento)
          ))
          .sort((a, b) => (a.puesto || '').localeCompare(b.puesto || ''))
      },

      ensureCatalogoCargado () {
        if (this.catalogoCargado) return Promise.resolve()
        if (this.catalogoPromise) return this.catalogoPromise

        this.catalogoPromise = this.cargarCatalogo()
          .then(() => {
            if (this.alive) this.catalogoCargado = true
          })
          .finally(() => {
            this.catalogoPromise = null
          })

        return this.catalogoPromise
      },

      cargarCatalogo () {
        return this.$http.get('auxiliares.catalogo.modal').then((response) => {
          if (!this.alive) return

          const data = response.data || {}
          this.areasTicket = Array.isArray(data.areasTicket) ? data.areasTicket : []
          this.allPuestos = Array.isArray(data.puestos) ? data.puestos : []
          this.usuariosKpi = Array.isArray(data.usuariosKpi) ? data.usuariosKpi : []
          this.jefesActivosIds = new Set(
            (Array.isArray(data.jefesActivosIds) ? data.jefesActivosIds : [])
              .map((id) => Number(id))
              .filter((id) => id > 0)
          )
          this.mapaDeptAreaTicket = data.mapaDeptAreaTicket && typeof data.mapaDeptAreaTicket === 'object'
            ? data.mapaDeptAreaTicket
            : {}
          this.areas = Array.isArray(data.departamentos) ? data.departamentos : []

          this.actualizarMapaDesdeTabla()
        }).catch((error) => {
          this.guardarSiActivo(() => {
            this.validarError(error.response && error.response.data
              ? error.response.data.message
              : 'Error al cargar catálogo de auxiliares')
          })
          return Promise.reject(error)
        })
      },

      getAuxiliares () {
        return this.$http.get('auxiliares.all').then((response) => {
          this.guardarSiActivo(() => {
            this.desserts = response.data
            this.actualizarMapaDesdeTabla()
          })
        }).catch((error) => {
          this.guardarSiActivo(() => {
            this.validarError(error.response && error.response.data
              ? error.response.data.message
              : 'Error al cargar auxiliares')
          })
        })
      },

      actualizarMapaDesdeTabla () {
        const mapa = { ...this.mapaDeptAreaTicket }
        this.desserts.forEach((row) => {
          const idDepto = Number(row.iddepartamento)
          const idArea = Number(row.idareas_ticket)
          if (idDepto > 0 && idArea > 0) {
            mapa[idDepto] = idArea
          }
        })
        this.mapaDeptAreaTicket = mapa

        if (!this.areas.length) return

        this.areas = this.areas.map((depto) => {
          const idDepto = Number(depto.iddepartamento)
          const idareasTicket = Number(depto.idareas_ticket) || Number(mapa[idDepto]) || 0
          const areaRow = this.areasTicket.find((area) => (
            Number(area.idareas_ticket) === idareasTicket
          ))
          return {
            ...depto,
            idareas_ticket: idareasTicket,
            area_ticket: areaRow ? areaRow.area : (depto.area_ticket || ''),
          }
        })
      },

      resetFormulario () {
        this.area = null
        this.puesto = null
        this.usuario = null
        this.puestos = []
      },

      findAreaForItem (item) {
        if (item.iddepartamento) {
          const porDepartamento = this.areas.find((area) => (
            Number(area.iddepartamento) === Number(item.iddepartamento)
          ))
          if (porDepartamento) return porDepartamento
        }

        if (item.departamento) {
          const porNombre = this.areas.find((area) => (
            this.normalizarTexto(area.departamento) === this.normalizarTexto(item.departamento)
          ))
          if (porNombre) return porNombre
        }

        if (item.idareas_ticket) {
          const idArea = Number(item.idareas_ticket)
          const porArea = this.areas.find((area) => Number(area.idareas_ticket) === idArea)
          if (porArea) return porArea
        }

        return null
      },

      findPuestoInArea (area, idpuesto) {
        if (!idpuesto) return null
        return this.allPuestos.find((puesto) => Number(puesto.idpuesto) === Number(idpuesto)) || null
      },

      async abrirDialogo () {
        this.cargar = true
        try {
          await this.ensureCatalogoCargado()
          if (!this.alive) return

          this.editedIndex = -1
          this.editedItem = Object.assign({}, this.defaultItem)
          this.resetFormulario()
          this.dialog = true
        } finally {
          if (this.alive) this.cargar = false
        }
      },

      async editItem (item) {
        this.cargar = true
        try {
          await this.ensureCatalogoCargado()
          if (!this.alive) return

          this.editedIndex = this.desserts.indexOf(item)
          this.editedItem = Object.assign({}, item)
          this.resetFormulario()

          const area = this.findAreaForItem(item)
          this.skipCascadeReset = true

          if (area) {
            this.area = area
            this.puestos = this.getPuestosPorDepartamento(area)

            const puestoGuardado = this.findPuestoInArea(area, item.idpuesto)
            if (puestoGuardado) {
              this.puesto = puestoGuardado
            }

            this.usuario = this.usuariosActivos.find((usuario) => (
              Number(usuario.id_usuario) === Number(item.id_usuario)
            )) || {
              id_usuario: item.id_usuario,
              nombre_completo: item.nombre_completo,
            }
          }

          this.$nextTick(() => {
            this.skipCascadeReset = false
          })

          this.dialog = true
        } finally {
          if (this.alive) this.cargar = false
        }
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.resetFormulario()
        })
      },

      deleteItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.cargar = true
        this.$http.delete('auxiliares.delete/' + this.editedItem.idauxi_area).then(() => {
          this.guardarSiActivo(() => {
            this.validarSuccess('Auxiliar eliminado correctamente')
            this.getAuxiliares()
            this.closeDelete()
          })
        }).catch((error) => {
          this.guardarSiActivo(() => {
            this.validarError(error.response && error.response.data
              ? error.response.data.message
              : 'Error al eliminar auxiliar')
          })
        }).finally(() => {
          this.guardarSiActivo(() => { this.cargar = false })
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (!this.area || !this.puesto || !this.usuario) {
          this.validarError('Datos vacíos')
          return
        }

        const idareasTicket = this.getIdAreasTicket(this.area)
        if (!idareasTicket) {
          this.validarError(
            `El departamento "${this.area.departamento}" no tiene área de ticket asignada. Revisa el catálogo de Áreas.`
          )
          return
        }

        const auxiliarExistente = this.desserts.find((row) => (
          Number(row.id_usuario) === Number(this.usuario.id_usuario)
          && Number(row.idauxi_area) !== Number(this.editedItem.idauxi_area)
          && Number(row.activo) === 1
        ))

        if (auxiliarExistente) {
          this.validarError(
            `Este usuario ya está registrado como auxiliar (${auxiliarExistente.departamento || auxiliarExistente.area}). Edita el registro existente.`
          )
          return
        }

        if (this.jefesActivosIds.has(Number(this.usuario.id_usuario))) {
          this.validarError('Este usuario ya está registrado como encargado de área. No puede agregarse como auxiliar.')
          return
        }

        this.editedItem.idareas_ticket = idareasTicket
        this.editedItem.id_usuario = this.usuario.id_usuario
        this.editedItem.idpuesto = this.puesto.idpuesto
        this.editedItem.iddepartamento = this.area.iddepartamento

        const payload = {
          idauxi_area: this.editedItem.idauxi_area,
          idareas_ticket: this.editedItem.idareas_ticket,
          id_usuario: this.editedItem.id_usuario,
          idpuesto: this.editedItem.idpuesto,
          iddepartamento: this.editedItem.iddepartamento,
        }

        this.cargar = true

        if (this.editedIndex > -1) {
          this.$http.put('auxiliares.update/' + payload.idauxi_area, payload).then(() => {
            this.guardarSiActivo(() => {
              this.validarSuccess('Auxiliar actualizado correctamente')
              this.getAuxiliares()
              this.close()
            })
          }).catch((error) => {
            this.guardarSiActivo(() => {
              this.validarError(error.response && error.response.data
                ? error.response.data.message
                : 'Error al actualizar auxiliar')
            })
          }).finally(() => {
            this.guardarSiActivo(() => { this.cargar = false })
          })
        } else {
          this.$http.post('auxiliares.add', payload).then(() => {
            this.guardarSiActivo(() => {
              this.validarSuccess('Auxiliar agregado correctamente')
              this.getAuxiliares()
              this.close()
            })
          }).catch((error) => {
            this.guardarSiActivo(() => {
              this.validarError(error.response && error.response.data
                ? error.response.data.message
                : 'Error al agregar auxiliar')
            })
          }).finally(() => {
            this.guardarSiActivo(() => { this.cargar = false })
          })
        }
      },
    },
  }
</script>
